import script from "./CertBatchManagementView.vue?vue&type=script&lang=ts&setup=true"
export * from "./CertBatchManagementView.vue?vue&type=script&lang=ts&setup=true"

import "./CertBatchManagementView.vue?vue&type=style&index=0&id=e36650dc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e36650dc"]])

export default __exports__